import { useState } from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import MobileNav from "../components/Common/MobileNav";
import PageTitle from "../components/Common/PageTitle";
import Sidebar from "../components/Common/Sidebar";

const Error = () => {
  const [isSidebarActive, setIsSidebarActive] = useState(false);
  return (
    <>
      <PageTitle value="Lost | SHWETFLIX" />
      <MobileNav setIsSidebarActive={setIsSidebarActive} />
      <div className="flex flex-col md:flex-row">
        <Sidebar
          setIsSidebarActive={setIsSidebarActive}
          isSidebarActive={isSidebarActive}
        />

        <div className="flex flex-grow items-center justify-center py-7 border-l px-[2vw] border-gray-darken min-h-screen">
          <div className="flex flex-col items-center justify-center">
            <LazyLoadImage
              src="/404.svg"
              alt="404Pic"
              effect="opacity"
              className="w-[30vw] min-w-[250px] object-cover rounded-xl "
            />
            <p className="mt-10 text-white text-xl md:text-2xl text-center">
              Oops 😅 ! Looks like you're lost !
            </p>
            <div className="flex justify-center">
              <Link
                to="/"
                className="px-4 py-2 m-5 rounded-full uppercase bg-dark-darken text-md text-primary font-medium transition duration-300 shadow-md shadow-gray-darken
                hover:scale-105 hover:shadow-md hover:shadow-gray-darken hover:bg-white"
              >
                Go to Homepage
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Error;
